module.exports = __webpack_public_path__ + "media/images/graph_elasticity-0e6c7e03a0ec466bf4e84a42b8a6d60a.svg";